var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-ui-spinner",class:_vm.classes,style:(_vm.styles),attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden"},[_vm._v(" Loading... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }